<h4 class="">
  <p class="text-center">Machines</p>
</h4>
<div class="ui-toolbar">
  <input type="text" pInputText class="form-control" size="50" placeholder="Filter" (input)="dt.filterGlobal($event.target.value, 'contains')" style="width:auto">
</div>

<p-table #dt [columns]="cols" [value]="machines" [paginator]="true" [rows]="10" selectionMode="single" [(selection)]="selectedMachine">
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th *ngFor="let col of columns">
        {{col.header}}
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-columns="columns">
    <tr [pSelectableRow]="rowData">
      <td *ngFor="let col of columns">
        {{rowData[col.field]}}
      </td>
    </tr>
  </ng-template>
</p-table>



// WEBPACK FOOTER //
// ./src/app/pages/machine/machines.component.html